import "./RadioProperty.css"
import "./Property.css"
import {Labeled} from "./Basics";
import {RadioButton} from "primereact/radiobutton";
import React from "react";

type Properties = Labeled & {
    id: number
    category: string
    checked: boolean
    onChange: (val: number) => void
}

function RadioProperty(props: Properties) {
    function handleRadioChange() {
        if (props.onChange != null) {
            props.onChange(props.id)
        }
    }

    const iId = props.id + ""

    return <>
        <div key={props.id} className="property-element property-radio-element">
            <div className="radio-input">
                <RadioButton
                    inputId={iId} name="category" value={props.category}
                    onChange={handleRadioChange}
                    checked={props.checked}/>
            </div>
            <label htmlFor={iId} className="radio-label">{props.label}</label>
        </div>
    </>
}

export default RadioProperty